import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DatatableComponent } from '@basis/angular-components';
import { PadraoService } from 'app/service/padrao.service';
import { SelectItem } from 'primeng/primeng';
import { Locale } from "../util/locale.ptbr";

@Component({
    selector: 'filter-funcionalidade-perfil',
    template: `
        <form [formGroup]="filtro" novalidate>
            <div class="ui-g-12 ui-md-12 ui-lg-12 form-group">
                <form-select class="ui-g-12 ui-md-6 ui-lg-4" 
                             label="Sistema" formControlName="id_sistema" 
                             [options]="listaSistema| formatSelectItem:'id':'nome'">
                </form-select>
                <form-select class="ui-g-12 ui-md-6 ui-lg-4" 
                             label="Perfil" formControlName="id_perfil" 
                             [options]="listaPerfil | formatSelectItem:'id':'nome'">
                </form-select>
            </div>
        </form>

        <div class="ui-g-12">
        </div>
        
        <div class="ui-g-10 ui-md-4 ui-lg-3" style="float: right; margin-right: 9%;" *ngIf="btnEnabled">
            <button pButton type="button" [label]="btnLabel" class="ui-button-mandalay" icon="ui-icon-plus" [routerLink]="['./cadastrar']" ></button>
        </div>
    
        <div class="ui-g-10 ui-md-4 ui-lg-3" style="float: right; margin-right: 20px;" *ngIf="btnEnabledConsultar && btnEnabled">
            <button pButton type="button" [label]="btnLabelConsultar" class="ui-button" icon="ui-icon-search" (click)="consultar($event)" ></button>
        </div>
    
        <div class="ui-g-10 ui-md-4 ui-lg-3" style="float: right; margin-right: 9%;" *ngIf="btnEnabledConsultar && !btnEnabled">
            <button pButton type="button" [label]="btnLabelConsultar" class="ui-button" icon="ui-icon-search" (click)="consultar($event)" ></button>
        </div>
    `})
export class FilterFuncionalidadePerfilComponent implements OnInit {
    @Output() quandoAlterarFiltroSistema = new EventEmitter<any>();
    @Input() filtro: FormGroup;
    @Input() listagem: DatatableComponent;
    @Input() btnEnabled: boolean = true;
    @Input() btnEnabledConsultar: boolean = true;
    @Input() btnLabel: string = "Adicionar";
    listaSistema: SelectItem[];
    listaPerfil: SelectItem[];
    btnLabelConsultar:string = "Consultar"

    constructor(public locale: Locale, public service: PadraoService){ }

    ngOnInit(): void {
        this.init();
    }

    init(){       
        this.filtro.get('id_perfil').disable();

        this.service.ListarTodos('sistema', 'Unidades').subscribe(
            data =>  this.listaSistema = data
        );

        this.filtro.get("id_sistema").valueChanges.subscribe(x => {

            this.service.ListarTodos('perfil', { id_sistema: x, query: 'ativo' }).subscribe(
                data => {
                    this.listaPerfil = data;
                    this.filtro.get('id_perfil').enable();
                }
            );
        });
    }

    /** 
     * Envia a consulta a ser realizada
     */
    consultar(event: any) {
        this.listagem.refresh(this.filtro.value);
    }
}


// WEBPACK FOOTER //
// ./src/app/funcionalidade-perfil/funcionalidade-perfil-filter.component.ts